import request from "@/utils/request";

export function getExpansionDashboard(data, options = {}) {
  return request({
    method: "post",
    url: "/expansions/dashboard",
    data,
    ...options,
  });
}

export function getExpansionLookup(data, options = {}) {
  return request({
    method: "post",
    url: "/expansions/lookup",
    data,
    ...options,
  });
}

export function getExpansionSelect(data, options = {}) {
  return request({
    method: "post",
    url: "/expansions/select",
    data,
    ...options,
  });
}

export function getExpansionMarkers(data, options = {}) {
  return request({
    method: "post",
    url: "/expansions/companies/markers",
    data,
    ...options,
  });
}

export function getExpansionCompanySearch(data, options = {}) {
  return request({
    method: "post",
    url: "/expansions/companies/search",
    data,
    ...options,
  });
}

export function getExpansionCompanyLookup(data, options = {}) {
  return request({
    method: "post",
    url: "/expansions/companies/lookup",
    data,
    ...options,
  });
}

// Batch expansion summaries for a SET of companies (comparison grids/tables) — one
// round-trip, no per-company fan-out or 404s. Returns { data: { [domain_search_id]: {...} } }.
export function getExpansionCompare(data, options = {}) {
  return request({
    method: "post",
    url: "/expansions/companies/compare",
    data,
    silent: true,
    ...options,
  });
}

// Lazy per-category pulse drill-down — complete, picker-scoped events for a set of signal types.
export function getExpansionPulseEvents(data, options = {}) {
  return request({
    method: "post",
    url: "/expansions/companies/pulse_events",
    data,
    silent: true,
    ...options,
  });
}

// Activity-pulse bars — backend-bucketed (fixed PULSE_BAR_COUNT slices over the picker window).
export function getCompanyActivityPulse(data, options = {}) {
  return request({
    method: "post",
    url: "/expansions/companies/activity_pulse",
    data,
    silent: true,
    ...options,
  });
}

export function getExpansionSignalTypes(data, options = {}) {
  // Non-critical fetch — the drawer / dropdown both have a working
  // taxonomy fallback when this 404s (deployed dev-api may lag). `silent`
  // keeps a stale-deploy toast from spamming users; callers that want the
  // toast can pass `{ silent: false }`.
  return request({
    method: "post",
    url: "/expansions/types",
    data,
    silent: true,
    ...options,
  });
}

export function getExpansionRecent(data, options = {}) {
  return request({
    method: "post",
    url: "/expansions/dashboard/recent",
    data,
    ...options,
  });
}

export function getExpansionWideExpanders(data, options = {}) {
  return request({
    method: "post",
    url: "/expansions/dashboard/wide-expanders",
    data,
    ...options,
  });
}

// Powers the For-you tab: caller's saved company lists with stage-transition
// activity in the current dashboard window. Same window/direction params as
// /wide-expanders so the panel speaks one filter language end-to-end.
export function getExpansionSavedListActivity(data, options = {}) {
  return request({
    method: "post",
    url: "/expansions/dashboard/saved-list-activity",
    data,
    ...options,
  });
}

export function saveCompanyToList(data, options = {}) {
  return request({
    method: "post",
    url: "/saved/companies/add",
    data,
    ...options,
  });
}

// 406/40606 is handled by the global blob interceptor — no call-site wiring needed.
export function exportExpansion(data, options = {}) {
  return request({
    method: "post",
    url: "/expansions/companies/export",
    data,
    responseType: "blob",
    ...options,
  });
}

// Signals public-API surface — symmetric with companies/* (search → lookup →
// select → export). Filter contract is identical across search/select/export
// so a caller can hand a /select result straight to /export.
export function lookupExpansionSignal(data, options = {}) {
  return request({
    method: "post",
    url: "/expansions/signals/lookup",
    data,
    ...options,
  });
}
export function searchExpansionSignals(data, options = {}) {
  return request({
    method: "post",
    url: "/expansions/signals/search",
    data,
    ...options,
  });
}
export function selectExpansionSignals(data, options = {}) {
  return request({
    method: "post",
    url: "/expansions/signals/select",
    data,
    ...options,
  });
}
export function exportExpansionSignals(data, options = {}) {
  return request({
    method: "post",
    url: "/expansions/signals/export",
    data,
    responseType: "blob",
    ...options,
  });
}

// Saved-view CRUD reuses /search's wrappers in @/api/company; the
// /saved_search_types lookup is the only thing not already exported.
export function getSavedSearchTypes(options = {}) {
  return request({
    method: "get",
    url: "/saved_search_types",
    ...options,
  });
}
